import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "hosting"
    }}>{`Hosting`}</h2>
    <p>{`You can use any hosting: shared hosting with ssh, VM hosting, VDS hosting,
NodeJS hosting, DigitalOcean, cloud services like Heroku, Amazon AWS, Google
Cloud, any... All you need is MERN stack (MongoDB + ExpressJS + ReactJs +
NodeJS), nothing special. You can install it on virtual machine, or you can use
"out of the box" services like Heroku, Google Firebase etc...`}</p>
    <p>{`I'll use `}<a parentName="p" {...{
        "href": "https://m.do.co/c/a1d5495e08b2"
      }}>{`DigitalOcean`}</a>{` to deploy Cezerin.`}</p>
    <p>{`Register by this link at DigitalOcean and receive free 10\\$ coupon to your
account.`}</p>
    <p>{`You can add your site for free for 2 month. 5\\$ per month. coupon code is
ACTIVATE10, activate it in your profile - billing tab.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      